import React from 'react';
import { useBugReportTypeComponent } from './useBugReportTypeComponent';
import { Box, Grid } from '@mui/material';
import UploadIcon from '@mui/icons-material/CloudUploadOutlined';
import AppFormSelectWrapper from '../../../../components/designe/app-form-select-wrapper';
import { useTranslation } from 'react-i18next';
import AppButton from '../../../../components/designe/app-button/AppButton';
import { useStyles } from './AddBugReportType.styles';
import theme from '../../../../styles/theme';
import { IExerciseProperty } from '../../../../types/interfaces/exercise-property';
import { ExercisePropertyType } from '../../../../shared/constants';
import AppFormTextField from '../../../../components/designe/app-form-text-field';
import AppEntityAvatar, {
  AvatarSize,
} from '../../../../components/designe/app-entity-avatar/AppEntityAvatar';
import { AvatarTypes } from '../../../../components/designe/app-avatar/AppAvatar';
import { uploadFilesUtils } from '../../../../utils/upload-files-utils';
import { IBugReportType } from '../../../../types/interfaces/bug-report-type';

interface IAddBugReportTypeProps {
  bugReportType: IBugReportType;
  onClose: () => void;
}

export default function AddBugReportType(props: IAddBugReportTypeProps) {
  const { bugReportType, onClose } = props;
  const { t } = useTranslation();
  const { formik, isLoading, bugReportTypes } = useBugReportTypeComponent(
    onClose,
    bugReportType,
  );
  const { classes } = useStyles(theme);

  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={1}>
          <Grid item sm={12}>
            <AppFormTextField
              label={t('common.nameKey')}
              fullWidth
              name="nameKey"
              formik={formik}
            />
          </Grid>
          <Grid item sm={12}>
            <AppFormTextField
              label={t('common.priority')}
              fullWidth
              type="number"
              name="priority"
              formik={formik}
            />
          </Grid>
        </Grid>
        <Box className={classes.addExercisePropertyButtonWrapper}>
          <AppButton variant="outlined" onClick={() => onClose()}>
            {t('common.cancel')}
          </AppButton>
          <AppButton type="submit" loader={isLoading}>
            {bugReportType ? t('common.update') : t('common.create')}
          </AppButton>
        </Box>
      </form>
    </Box>
  );
}
